import { render, staticRenderFns } from "./AccordionMultiplosDiagnosticosSocioambientais.vue?vue&type=template&id=86c5f736&lang=pug"
import script from "./AccordionMultiplosDiagnosticosSocioambientais.vue?vue&type=script&lang=js"
export * from "./AccordionMultiplosDiagnosticosSocioambientais.vue?vue&type=script&lang=js"
import style0 from "./AccordionMultiplosDiagnosticosSocioambientais.vue?vue&type=style&index=0&id=86c5f736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports